<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">菜单名称</span>
        <el-input v-model.trim="name" placeholder="请输入菜单名称" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="createDate"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; ucAuthModuleAuthTreeFn()">
          搜索
        </el-button>
        <el-button type="primary" @click="editBtn(1)">
          新增菜单
        </el-button>
      </div>
    </el-row>

      
	  <el-tree
        :data="authTreeData.tableData"
        :check-strictly="checkStrictly" 
        ref="authTree"
        highlight-current 
        node-key="functionId"
        default-expand-all
        @check-change="handleCheckChange"
        @node-click="handleNodeClick"
        @check="handleCheck"
		@node-contextmenu="rightClick"
        :props="{id:'id',label:'name'}">
      </el-tree>
	  
	  
	  <!--鼠标右键点击出现页面-->
	            <div v-show="menuVisible" >
	              <el-menu
	                id = "rightClickMenu"
	                class="el-menu-vertical"
	                @select="handleRightSelect"
	                active-text-color="#fff"
	                text-color="#fff" style="background-color: #333333;">
	                <el-menu-item index="1" class="menuItem">
	                  <span slot="title">添加</span>
	                </el-menu-item>
	                <el-menu-item index="2" class="menuItem">
	                  <span slot="title">修改</span>
	                </el-menu-item>
	                <el-menu-item index="3" class="menuItem">
	                  <span slot="title">删除</span>
	                </el-menu-item>
	                <hr style="color: #ffffff">
	                <el-menu-item index="4" class="menuItem">
	                  <span slot="title">关闭</span>
	                </el-menu-item>
	              </el-menu>
	            </div>
	  

    <!-- 新增菜单 -->
    <el-dialog :title="editData.add === 1 ? '新增菜单' : '编辑菜单'" :visible.sync="editData.modal" width="500px">
	  
	  <el-form label-width="120px">
		  
		<el-form-item label="上级菜单名称">
			<el-select v-model="editData.superiorMenu" class="w250" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in parentMenuList" :key="index" :label="item.name" :value="item.id"/>
			</el-select>
		</el-form-item>

        <el-form-item label="菜单名称">
          <el-input v-model.trim="editData.name"  class="w250" placeholder="请输入菜单名称"/>
        </el-form-item>
		
		<el-form-item label="路径">
		  <el-input v-model.trim="editData.code"  class="w250" placeholder="请输入路径"/>
		</el-form-item>
		
      </el-form>
      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 权限设置 -->
    <el-dialog title="系统权限设置" :visible.sync="authData.modal" fullscreen>
      <el-table class="my-table" :data="authData.tableData" :header-row-class-name="'my-table-header'">
        <el-table-column align="center" prop="lineNumber" width="100px" label="行号"></el-table-column>
        <el-table-column align="center" prop="name.name" width="300px" label="名称"></el-table-column>
        <el-table-column align="left" label="权限明细">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.allCheck" @change="authAllChange($event, row)"
                         :indeterminate="row.indeterminate">
              全选
            </el-checkbox>
            <el-checkbox-group class="mt20" v-model="row.checkedList" @change="authChange($event, row)">
              <el-checkbox v-for="(item,index) in row.subNameList" :label="item.id" :key="index">
                {{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>


      <div slot="footer">
        <el-button @click="authData.modal = false">取 消</el-button>
        <el-button type="primary" @click="authSave">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
	getUcManagePage,
	//分页查询菜单列表
	getUcAuthModuleAuthPage,
	//查询菜单树
	ucAuthModuleAuthTree,
	//新增菜单
	addUcModuleAuth,
	//修改菜单
	updateUcModuleAuth,
	//查询所有菜单列表id、name
	queryUcModuleAuthListIdName,
	//删除菜单
	delUcModuleAuth,
	  
    getUserRolePage,
    addUserRole,
    editUserRole,
    delUserRole,
    getSystemPermSettings,
    addUserRoleFun,
	
  } from '@/api/index'

  export default {
    name: 'RoleAuth',
    data () {
      return {
		//搜索菜单名称
        name: '',
        createDate: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        editData: {
          modal: false,
          add: 1,
		  //菜单名称
          name: '',
		  //上级菜单名称
		  superiorMenu:'',
          id: '',
		  //路径
		  code:''
        },
		//上级菜单名称
		//二级商户类型
		parentMenuList:[],
        // 权限设置
        authData: {
          modal: false,
          roleId: '',
          tableData: [],
          tableLoading: false,
        },
		authTreeData: {
		  modal: false,
		  roleId: '',
		  tableData: [],
		  tableLoading: false,
		  //拥有权限集合
		  checkedList:''
		},
		checkStrictly: false,
		tmDisplay:'',
		menuVisible:''
      }
    },
    created () {
	  //查询菜单列表
      //this.getUserRolePageFn()
	  //查询菜单树
	  this.ucAuthModuleAuthTreeFn()
	  //查询所有菜单列表id、name
	  this.queryUcModuleAuthListIdNameFn()
    },
    methods: {
	  //查询所有菜单列表id、name
	  queryUcModuleAuthListIdNameFn(){
			this.tableLoading = true
			queryUcModuleAuthListIdName({}).then(res => {
			  this.parentMenuList = res.data
			}).finally(() => {
			  this.tableLoading = false
			})
	   },
      authSave () {
        let data =  this.authData.tableData;
        let checkArray = [];
        data.forEach(item => {
          let subName = item.name;
          let subItem = item.checkedList;
          let length = subItem.length;
          //数组有值在追加到一起
          if(length!=0){
           let id = subName.id;
            checkArray.push(id);
            subItem.forEach(item =>{
              checkArray.push(item);
            });
          }
        });
        addUserRoleFun({
          roleId: this.authData.roleId,
          functionIds: checkArray,
        }).then(res => {
          this.$message.success(res.data)
          this.authData.modal = false
        })
      },
      authAllChange (val, row) {
        row.checkedList = val ? row.subNameList.map(item => item.id) : []
        row.indeterminate = false
      },
      authChange (value, row) {
        let checkedCount = value.length
        row.allCheck = checkedCount === row.checkedList.length
        row.indeterminate = checkedCount > 0 && checkedCount < row.subNameList.length
      },
	  //查询菜单树
	  ucAuthModuleAuthTreeFn(){
		  this.tableLoading = true
		  ucAuthModuleAuthTree({
		    pageNum: this.pages.page,
		    roleName: this.roleName,
		    startTime: this.createDate && this.createDate.length ? this.createDate[0] : '',
		    endTime: this.createDate && this.createDate.length > 1 ? this.createDate[1] : '',
		    roleId: this.roleId
		  }).then(res => {
		    this.authTreeData.tableData = res.data
		    		  	// let haveAuthority = res.data.haveAuthority		
		    		  	// if (haveAuthority) {
		    		  	// 	this.checkStrictly = true 
		    		  	// 	haveAuthority.forEach(value=>{//真的大坑，我自己摸索好久！！！
		    		  	// 	this.$nextTick(() => {
		    		  	// 	console.info("haveAuthority    ",value)
		    		  	// 	this.$refs.authTree.setChecked(value,true,false) //给树节点赋值
		    		  	// 	 })
		    		  	// 	this.checkStrictly = false //重点： 赋值完成后 设置为false
		    		  	// 	})
		    		  	// }
		  }).finally(() => {
		    this.tableLoading = false
		  })
	  },
      getUserRolePageFn () {
        this.tableLoading = true
        getUcAuthModuleAuthPage({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createDate && this.createDate.length ? this.createDate[0] : '',
          updateTime: this.createDate && this.createDate.length > 1 ? this.createDate[1] : '',
          roleId: this.roleId
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getUserRolePageFn()
      },
      addBtn () {
        if (this.editData.add == 1) {
          //确定保存
          addUcModuleAuth({
			parentId:this.editData.superiorMenu,
            name: this.editData.name,
			code:this.editData.code
          }).then(res => {
            this.$message.success(res.msg)
            this.editData.modal = false
            this.ucAuthModuleAuthTreeFn()
          })
        } else {
          //确定编辑
          updateUcModuleAuth({
            id: this.editData.id,
            name: this.editData.name,
			parentId:this.editData.superiorMenu,
			code:this.editData.code
          }).then(res => {
            this.$message.success(res.msg)
            this.editData.modal = false
            this.ucAuthModuleAuthTreeFn()
          })
        }
      },
      //1新增 2编辑 3删除 4权限设置
      editBtn (t, row) {
        switch (t) {
          case 1:
            //弹出新增角色弹出层
            this.editData = {
              modal: true,
              add: 1,
              name: '',
			  code:''
            }
            break

          case 2:
            //弹出编辑角色弹出层
            this.editData = {
              modal: true,
              add: 2,
              id: row.id,
			  superiorMenu:row.parentId,
              name: row.name,
			  code: row.code
            }
            break

          case 3:
            this.$confirm(`确认要删除吗`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delUcModuleAuth({
                ids: [row.id],
              }).then(res => {
                this.$message.success(res.msg)
                this.getUserRolePageFn()
              })
            }).catch(() => {
            })
            break

          case 4:
            getSystemPermSettings(row.roleId).then(res => {
              let tableData = res.data
              tableData.forEach(item => {
                item.indeterminate = false
                item.allCheck = item.subNameList.every(subName => subName.flag)
                item.checkedList = item.subNameList.filter(subName => subName.flag).map(subName => subName.id)
              })

              this.authData = {
                modal: true,
                roleId: row.roleId,
                tableData
              }
            })
            break
        }
      },
	  handleCheckChange(){
	  	
	  },
	  handleNodeClick(data, node) {
	  		 console.info("节点双击事件");
	  },
	  handleCheckChange(){
	  	
	  },
	  handleCheck(data,checked){
	  	//checked.checkedKeys  选中的节点id数组z
	  	//checked.halfCheckedKeys 半选中节点id数组
	  	this.moduleids = checked.halfCheckedKeys.concat(checked.checkedKeys); //选中节点和半选中节点所有的id
	  },
	  //节点右击事件
	 rightClick(event, object, value, element) {
	        if (this.objectID !== object.id) {
	          this.objectID = object.id;
	          this.menuVisible = true;
	          this.DATA = object;
	          this.NODE = value;
	        } else {
	          this.menuVisible = !this.menuVisible;
	        }
	        document.addEventListener('click',(e)=>{
	          this.menuVisible = false;
	        })
	        let menu = document.querySelector("#rightClickMenu");
	        /* 菜单定位基于鼠标点击位置 */
	        menu.style.left = event.clientX + 20 + "px";
	        menu.style.top = event.clientY - 30 + "px";
	        menu.style.position = "absolute"; // 为新创建的DIV指定绝对定位
	        menu.style.width = 160 + "px";
	        /*console.log("右键被点击的左侧:",menu.style.left);
	          console.log("右键被点击的顶部:",menu.style.top);*/
	        //        console.log("右键被点击的event:",event);
	        // console.log("右键被点击的object:", object);
	        // console.log("右键被点击的value:", value);
	        // console.log("右键被点击的element:", element);
	      },
		  handleRightSelect(key) {
		        console.log(key);
		        if (key == 1) {
		          this.NodeAdd(this.NODE, this.DATA);
		          this.menuVisible2 = false;
		        } else if (key == 2) {
		          this.NodeEdit(this.NODE, this.DATA);
		          this.menuVisible2 = false;
		        } else if (key == 3) {
		          this.NodeDel(this.NODE, this.DATA);
		          this.menuVisible2 = false;
		        } else if(key == 4){
		          console.log('4')
		        }
		      },
			  //新增节点
			  NodeAdd(n, d){
				  //弹出新增角色弹出层
				  this.editData = {
				    modal: true,
				    add: 1,
					superiorMenu:d.id,
				    name: ''
				  }
			  			console.log(n, d)
		},
		//删除节点			
		NodeDel(n, d){
			let nodeId = d.id
			
			this.$confirm(`确认要删除吗`, '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
		
		delUcModuleAuth({
			ids:[nodeId]
		}).then(res => {
			if(res.code === 200){
				this.$message.success(res.msg)
				//查询菜单树
				this.ucAuthModuleAuthTreeFn()
			}else{
				this.$message.error(res.msg)
			}
		})
			}).catch(() => {
			})
		
			console.log(n, d)
			console.info("删除节点id:" ,nodeId)
		},
		//修改节点
		NodeEdit(n, d){
			let nodeId = d.id
			
			//弹出编辑角色弹出层
			this.editData = {
			  modal: true,
			  add: 2,
			  id: d.id,
			  superiorMenu:d.parentId,
			  name: d.name,
			  code: d.code
			}
			console.log(n, d)
			console.info("修改节点id:" ,nodeId)
		},
    }
  }
</script>

<style scoped>

</style>
